<template>
    <v-footer class="blue white--text">
        <div style="width:100%" class="text-xs-center">2017 - 2021 | © IQVIA</div>
    </v-footer>
</template>
<script>
    export default {
        name: 'footer'
    };
</script>



// WEBPACK FOOTER //
// Footer.vue?c9adb86e